<template>
  <div>
    <v-card
      class="mx-2"
      @click="setOutlet"
      hover
    >
      <v-img
        :src="outletImage"
        @error="noOutletImage"
        height="180"
      >
      </v-img>
      <v-card-title class="pb-3" :style="myStyle">
        <v-layout row>
          <v-flex class="nowrap-text">
            <span>{{ outletName }}{{ nameSuffix }}</span>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="location pt-0">
        <v-layout
          v-if="outletLocalhost"
          row
        >
          <v-flex class="nowrap-text">
            <v-icon
              class="middle"
              small
              color="#515152"
            >fas fa-map-marker-alt</v-icon>
            <span>{{ outletLocalhost }}</span>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isNavigationFailure } from 'vue-router/src/util/errors'
import _ from 'lodash'

export default {
  data: () => ({
    outletImageFail: false
  }),
  props: {
    outlet: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      default: function () {
        return 'full_name'
      }
    },
    location: {
      type: String,
      default: function () {
        return 'location'
      }
    },
    nameSuffix: {
      type: String,
      default: function () {
        return null;
      }
    }
  },
  computed: {
    ...mapGetters('config', [
      'gid', 'rid', 'pictures', 'photo', 'theme'
    ]),
    ...mapGetters('cart', [
      'cartQty'
    ]),
    ...mapGetters('area', [
      'selectedAreaMode',
    ]),
    outletImage () {
      if (!this.outletImageFail && this.outlet.photo) {
        return this.outlet.pictures + this.outlet.photo
      }
      return window.config.sharedPictures + 'sample_bg.jpg'
    },
    myStyle () {
      if (this.rid && parseInt(this.rid) === parseInt(this.outlet.restaurant_id)) {
        // this.$store.dispatch('config/changeRid', 0)
        return {
          color: '#41802e',
          fontWeight: 800
        }
      }
      return ''
    },
    outletName() {
      return _.get(this.outlet, this.name);
    },
    outletLocalhost() {
      return _.get(this.outlet, this.location);
    }
  },
  methods: {
    setOutlet () {
      const iOrderVersion = this.outlet.iorder_version;

      this.$bus.$emit('showFullLoading', true)

      let outletRestaurantId = parseInt(this.outlet.restaurant_id)
      let outletGroupId = parseInt(this.outlet.group_id)

      // dine_mode, 1:takeaway, 2:delivery
      if (iOrderVersion == 2) {
        let dineMode = 0;
        if (this.selectedAreaMode.isTakeaway) {
          dineMode = 1;
        } else if (this.selectedAreaMode.isDelivery) {
          dineMode = 2;
        }

        window.location.href=`https://iorder2.aptsys.com.sg/${outletGroupId}/${outletRestaurantId}/menu?dine_mode=${dineMode}`;
        return;
      }

      if (this.rid && parseInt(this.rid) === outletRestaurantId) {
        // To refresh cookie's expiry time
        this.$store.dispatch('config/changeRid', this.rid)
        // this.$router.push({ name: 'welcome' }).catch(failure => {
        //   if (isNavigationFailure(failure)) {
        //     // show a small notification to the user
        //   }
        // })
        this.$router.push({ name: 'menu', params: { gid: this.outlet.group_id, rid: this.outlet.restaurant_id }})
          .catch((error) => {
            console.log('this.$router.push')
            console.log(error);
            console.log('end this.$router.push');
          });
      } else {
        // Define actions and params
        let action, param
        if (this.gid && parseInt(this.gid) === outletGroupId) {
          action = 'changeOutlet'
          param = this.outlet.restaurant_id
        } else {
          action = 'changeStore'
          param = {
            gid: this.outlet.group_id,
            rid: this.outlet.restaurant_id
          }
        }
        if (this.cartQty > 0) {
          this.$bus.$emit('showFullLoading', false)
          this.$store.dispatch('responseMessage', {
            type: 'error',
            title: 'Change Outlet',
            text: 'Your items in basket will be cleared when you change to another outlet. Are you sure?',
            modal: true,
            buttons: [
              { text: 'Cancel' },
              { text: 'Ok', action: action, param: param, path: 'welcome' }
            ]
          })
        } else {
          this.$store.dispatch(action, param)
          this.$router.push({ name: 'menu', params: { gid: this.outlet.group_id, rid: this.outlet.restaurant_id }})
            .catch((error) => {
              console.log('this.$router.push')
              console.log(error);
              console.log('end this.$router.push');
            });
          // this.$router.push({ name: 'welcome' }).catch(failure => {
          //   if (isNavigationFailure(failure)) {
          //     // show a small notification to the user
          //   }
          // })
        }
      }
    },
    noOutletImage () {
      this.outletImageFail = true
    }
  }
}
</script>

<style scoped>
.middle {
  padding: 3px;
}
.location {
  margin-top: -10px;
  height: 45px;
}
.nowrap-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/OutletSelector.vue